<div class="contentContainer">

    <!------------------------------------------------------------------------------ header -->

    <div fxLayout="row" fxLayoutAlign="space-between center" class="headerContentContainer">
        <div fxLayout="row">
            <div fxLayoutAlign="center center" class="grayLink" (click)="routeService.goBack()">
                <mat-icon class="linkIcon ft22">arrow_back</mat-icon>
            </div>
            <div>
                <h6 class="mgl10 ft500 ft16 mgb0 gray-9"> Empresas</h6>
            </div>
        </div>
        <div fxLayout="row">
            <div routerLink="/admin/form-empresas" class="mgl10 sqChip ft12 ft500 backGray9 shadow20">
                Agregar
            </div>
        </div>
    </div>

    <!------------------------------------------------------------------------------ Table -->

    <div class="tableContainer">

        <table class="fw">
            <!-- table Header -->
            <tr class="tableHeaderContainer">
                <th class="w-30">Nombre</th>
                <th class="w-20">Id</th>
                <th class="w-10">Cant. Cursos</th>
                <th class="w-10">Cant. Instr.</th>
                <th class="w-10">Cant. Ventas</th>
                <th class="w-10">Publicado</th>
                <th class="w-20">Fecha creación</th>
            </tr>

            <!-- table Data -->
            <tr *ngFor="let item of array;  let i=index">
                <td>
                    <div fxLayoutAlign="space-between">
                        <a routerLink="/empresa/{{item.id}}" class="mgl05 blueLink undrl ft500 ft12">{{item.nombre}}</a>
                        <mat-icon routerLink="/admin/form-empresas/{{item.id}}"
                            class="cursorPointer gray-4 ft18 linkIcon">edit
                        </mat-icon>
                    </div>
                </td>
                <td class="centertext"> {{item.id}}</td>
                <td class="centertext"> {{item.cantCursos}}</td>
                <td class="centertext"> {{item.cantInstructores}}</td>
                <td class="centertext"> {{item.cantVentas}}</td>
                <td class="centertext">
                    <div fxLayoutAlign="center center">
                        <div class="sqChip ft11 backGreen5 cursorDefault" *ngIf="item.publicado==true">
                            Publicado
                        </div>
                        <div class="sqChip ft11 backYellow5 cursorDefault" *ngIf="item.publicado==false">
                            Borrador
                        </div>
                    </div>
                </td>
                <td class="centertext ">
                    <span *ngIf="item.fechaCreacion" class="ft11">{{item.fechaCreacion.toDate() | date}}</span>
                </td>
            </tr>
        </table>
    </div>

</div>